import Box from '@redbubble/design-system/src/Box';
import Divider from '@redbubble/design-system/src/Divider';
import SimpleSearch from '@redbubble/design-system/src/SimpleSearch';
import Text from '@redbubble/design-system/src/Text';
import { defineMessages, useIntl } from '@redbubble/next/intl';
import React, { ReactNode } from 'react';
import { useEngageTextMessaging } from '../../../../hooks/useEngageTextMessaging';
import styles from './DiscoveryUnit.module.scss';

export const messages = defineMessages({
  titleMessage: {
    defaultMessage: 'Looking for something different?',
  },
  supportingMessage: {
    defaultMessage: 'Search below.',
  },
});
interface DiscoveryUnitProps {
  searchProductContext?: {
    id: string;
    label: string;
  } | null;
  children?: ReactNode;
}

export const DiscoveryUnit: React.FC<DiscoveryUnitProps> = ({
  searchProductContext,
  children,
}) => {
  const intl = useIntl();

  return (
    <Box className={styles.discoveryUnitContainer}>
      <Box display="flex" flexDirection="column">
        <Text element="h2" type="display3">
          {intl.formatMessage(messages.titleMessage)}
        </Text>
        <Text type="display5">
          {intl.formatMessage(messages.supportingMessage)}
        </Text>
      </Box>

      <Box className={styles.searchContainer}>
        <Box data-testid="simple-search">
          <SimpleSearch
            intl={intl}
            engagingPlaceholderMessages={useEngageTextMessaging()}
            productContext={searchProductContext}
          />
        </Box>
        {children}
      </Box>
      <Box className={styles.divider}>
        <Divider />
      </Box>
    </Box>
  );
};
